import { HashRouter, Routes, Route } from "react-router-dom";
import RegistrationForm from "./components/RegistrationForm";
import AdminDashboard from "./components/AdminDashboard";
import AdminConfig from "./components/AdminConfig";
import AdminFormsList from "./components/AdminFormsList";
import Home from "./components/Home";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/form/:formId" element={<RegistrationForm />} />
        <Route path="/admin" element={<AdminFormsList />} />
        <Route path="/admin/form/:formId" element={<AdminDashboard />} />
        <Route path="/admin/form/:formId/config" element={<AdminConfig />} />
        <Route path="*" element={
          <div style={{ textAlign: "center", padding: "50px", color: "white" }}>
            <h1>404 - Nie znaleziono</h1>
            <p>Ta strona nie istnieje.</p>
          </div>
        } />
      </Routes>
    </HashRouter>
  );
}

export default App;
